import React from 'react'

export * from './EnergyConsumptionSummary'
export { default as EnergyConsumptionSummary } from './EnergyConsumptionSummary'
export { default as EnergyFlowDiagram } from './EnergyFlowDiagram'
export type { EnergyConsumptionAndGenerationChartProps } from './types'

export { default as BillIncentivesTable } from './billSavings/BillIncentivesTable'
export type { PropTypes as BillSavingsProps } from './billSavings/BillSavingsChart.types'
export { buildBillSavingsBreakdownColors } from './billSavings/colors'
export * from './billSavings/constants'
export type { PropTypes as LifeTimeSavingsChartProps } from './lifetimeSavings/LifeTimeSavingsChart'

// Do not export EnergyConsumptionAndGenerationChart directly since its dependencies contains window variable which SSR doesn't like
export const EnergyConsumptionAndGenerationChart = React.lazy(() =>
  import('./EnergyConsumptionAndGenerationChart').then((m) => ({
    default: m.EnergyConsumptionAndGenerationChart,
  }))
)

export const BillSavingsChart = React.lazy(() =>
  import('./billSavings/BillSavingsChart').then((m) => ({
    default: m.default,
  }))
)
export const BillSavingsChartWithLabels = React.lazy(() =>
  import('./billSavings/BillSavingsChartWithLabels').then((m) => ({
    default: m.default,
  }))
)

export const LifeTimeSavingsChart = React.lazy(() =>
  import('./lifetimeSavings/LifeTimeSavingsChart').then((m) => ({
    default: m.default,
  }))
)
export const LifeTimeSavingsChartWithLabels = React.lazy(() =>
  import('./lifetimeSavings/LifeTimeSavingsChartWithLabels').then((m) => ({
    default: m.default,
  }))
)

export { PAYMENT_CHART_TABS } from './financialBenefits/constants'
export { default as FinancialBenefitsLegend } from './financialBenefits/FinancialBenefitsLegend'
export const CashFlowChart = React.lazy(() =>
  import('./financialBenefits/CashFlowChart').then((m) => ({
    default: m.default,
  }))
)
export const FinancialBenefitsChart = React.lazy(() =>
  import('./financialBenefits/FinancialBenefitsChart').then((m) => ({
    default: m.default,
  }))
)

